import UsageInfo from '../../components/UsageInfo';

export default function WebSiteOnizleme() {
  const odaListesi = [
    { ad: 'STANDART ÇİFT KİŞİLİK', fiyat: '350.00', pct: '% 15 ÖN ÖDEME', desc: 'Deniz manzaralı, geniş balkonlu ve modern dekore edilmiş standart oda.', icon:'🛏️' },
    { ad: 'DELUXE ÜÇ KİŞİLİK',       fiyat: '420.00', pct: '% 15 ÖN ÖDEME', desc: 'Ekstra geniş yataklar ve ayrı bir oturma alanı sunan lüks konaklama.', icon:'✨' },
    { ad: 'GENİŞ AİLE SÜİTİ',     fiyat: '580.00', pct: '% 20 ÖN ÖDEME', desc: 'İki ayrı oda ve ortak salonu ile aileler için ev konforunda tatil.', icon:'🏠' },
  ];

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      
      {/* Premium Header */}
      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm p-6 md:p-8 relative overflow-hidden">
        <div className="absolute top-0 right-0 -mr-16 -mt-16 w-64 h-64 bg-emerald-50 rounded-full blur-3xl opacity-60 pointer-events-none" style={{ transform: 'translateZ(0)', willChange: 'transform' }}></div>
        <div className="relative flex flex-col md:flex-row md:items-center justify-between gap-8">
          <div className="flex items-center gap-6 min-w-0">
            <div className="w-16 h-16 bg-gradient-to-br from-emerald-500 to-teal-700 rounded-2xl flex-shrink-0 flex items-center justify-center text-white text-3xl shadow-2xl shadow-emerald-200">🖥️</div>
            <div className="min-w-0">
              <h1 className="text-2xl md:text-3xl font-black text-gray-900 tracking-tighter truncate uppercase">Rezervasyon Formu Önizleme</h1>
              <p className="text-sm font-bold text-gray-400 mt-1 uppercase tracking-widest truncate">Müşterilerinizin gördüğü 4 adımlı rezervasyon motorunun simülasyonu</p>
            </div>
          </div>
          <a href="#" target="_blank" className="bg-white hover:bg-emerald-50 text-emerald-600 px-6 py-4 rounded-2xl text-[10px] font-black border-2 border-emerald-50 shadow-sm transition-[background-color,transform] duration-200 uppercase tracking-widest flex items-center gap-2">
             🔗 YENİ SEKMEDE AÇ ➹
          </a>
        </div>
      </div>

      <div className="max-w-6xl mx-auto">
        {/* Tarayıcı Simülasyonu Peneceresi */}
        <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-2xl overflow-hidden mb-8 transform hover:scale-[1.01] transition-transform duration-500 shadow-emerald-900/5">
          {/* Tarayıcı Barı */}
          <div className="bg-gray-100/80 backdrop-blur-sm border-b border-gray-200 px-6 py-4 flex items-center gap-6">
            <div className="flex gap-2">
              <div className="w-3.5 h-3.5 rounded-full bg-rose-400 border border-rose-500/30" />
              <div className="w-3.5 h-3.5 rounded-full bg-amber-400 border border-amber-500/30" />
              <div className="w-3.5 h-3.5 rounded-full bg-emerald-400 border border-emerald-500/30" />
            </div>
            <div className="flex-1 bg-white rounded-xl px-4 py-2 text-[11px] text-gray-400 font-mono border-2 border-gray-100 flex items-center gap-2 shadow-inner">
               <span className="text-emerald-500">🔒</span> hotelflow.com/rezervasyon/test-otel
            </div>
            <div className="hidden sm:flex items-center gap-4 text-xs grayscale opacity-30">
               <span>↻</span>
               <span>🏠</span>
            </div>
          </div>

          <div className="p-4 md:p-10 space-y-12">
            {/* Önizleme İçeriği - Otel Logo ve Header */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-b border-gray-100 pb-8">
              <div className="flex items-center gap-4">
                 <div className="w-14 h-14 bg-gray-900 rounded-2xl flex items-center justify-center text-white font-black text-xl shadow-lg">TF</div>
                 <div className="text-center md:text-left">
                    <p className="text-lg font-black text-gray-900 leading-none">TEST HOTELFLOW</p>
                    <p className="text-[10px] font-bold text-gray-400 mt-1 uppercase tracking-widest">Resmi Rezervasyon Motoru</p>
                 </div>
              </div>
              <div className="flex items-center gap-4 text-[10px] font-black text-gray-500 uppercase tracking-widest">
                 <span className="hover:text-indigo-600 transition-colors cursor-pointer">Ana Sayfa</span>
                 <span>·</span>
                 <span className="hover:text-indigo-600 transition-colors cursor-pointer">Telefon: 0533 697 49 11</span>
                 <span className="bg-gray-100 px-3 py-1.5 rounded-full border border-gray-200">🌐 TR ▼</span>
              </div>
            </div>

            {/* Step Stepper - Responsive */}
            <div className="flex items-center justify-center gap-2 md:gap-4 flex-wrap">
              {[
                { n: 1, l: 'ODA SEÇİMİ', active: true },
                { n: 2, l: 'MİSAFİR BİLGİSİ', active: false },
                { n: 3, l: 'ÖDEME', active: false },
                { n: 4, l: 'SONUÇ', active: false }
              ].map((s, i) => (
                <div key={s.n} className="flex items-center">
                  <div className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-xl flex items-center justify-center text-[11px] font-black shadow-sm transition-[background-color,border-color,transform] duration-300 border-2 ${
                      s.active ? 'bg-indigo-600 border-indigo-600 text-white shadow-indigo-100 scale-110' : 'bg-white border-gray-100 text-gray-300'
                    }`}>{s.n}</div>
                    <span className={`text-[10px] font-black tracking-widest uppercase hidden lg:block ${s.active ? 'text-indigo-600' : 'text-gray-300'}`}>{s.l}</span>
                  </div>
                  {i < 3 && <div className="w-6 md:w-16 h-[2px] bg-gray-100 mx-2" />}
                </div>
              ))}
            </div>

            {/* Arama Barı - Premium Simulation */}
            <div className="bg-white rounded-[2rem] border-2 border-gray-100 p-6 md:p-8 shadow-xl shadow-gray-100/50">
               <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 items-end">
                  <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-2">GİRİŞ TARİHİ</label>
                    <div className="w-full bg-gray-50/50 border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-xs font-bold text-gray-700 flex items-center gap-3">
                       <span>📅</span> 18 MART 2026
                    </div>
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-2">ÇIKIŞ TARİHİ</label>
                    <div className="w-full bg-gray-50/50 border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-xs font-bold text-gray-700 flex items-center gap-3">
                       <span>📅</span> 20 MART 2026
                    </div>
                  </div>
                  <div>
                    <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest block mb-2.5 ml-2">KONAKLAYAN</label>
                    <div className="w-full bg-gray-50/50 border-2 border-gray-100 rounded-2xl px-5 py-3.5 text-xs font-bold text-gray-700 flex items-center justify-between">
                       <span className="flex items-center gap-3"><span>👥</span> 2 YETİŞKİN</span>
                       <span className="text-[8px]">▼</span>
                    </div>
                  </div>
                  <button className="w-full bg-indigo-600 text-white py-4 rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-xl shadow-indigo-100 hover:bg-indigo-700 active:scale-95 transition-all">
                    ODALARI LİSTELE »
                  </button>
               </div>
            </div>

            <div className="space-y-6">
              <p className="text-[10px] font-black text-indigo-500 uppercase tracking-widest text-center">
                 🔍 18.03.2026 — 20.03.2026 tarihleri arasında (2 Gece) Müsaitlik Bulundu
              </p>

              {/* Oda Kartları */}
              {odaListesi.map((oda, idx) => (
                <div key={idx} className="bg-white rounded-3xl border-2 border-gray-100 p-6 flex flex-col lg:flex-row items-center gap-8 hover:border-indigo-100 hover:shadow-2xl hover:shadow-indigo-50 transition-all group duration-500">
                  <div className="w-full lg:w-48 h-36 bg-gray-50 rounded-2xl flex items-center justify-center text-4xl shadow-inner border border-gray-100 flex-shrink-0 group-hover:scale-105 transition-transform">
                    {oda.icon}
                  </div>
                  <div className="flex-1 space-y-3 text-center lg:text-left">
                    <div className="flex flex-col lg:flex-row lg:items-center gap-3">
                       <h3 className="text-base font-black text-gray-900 tracking-tight uppercase">{oda.ad}</h3>
                       <span className="text-[9px] font-black bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full border border-emerald-100 self-center lg:self-auto">{oda.pct}</span>
                    </div>
                    <p className="text-[11px] font-bold text-gray-400 leading-relaxed uppercase tracking-tighter max-w-lg">{oda.desc}</p>
                    <div className="flex items-center justify-center lg:justify-start gap-4">
                       <span className="text-[10px] font-black text-indigo-400 uppercase tracking-widest cursor-pointer hover:underline underline-offset-4">Detayları Göster</span>
                       <span className="w-1 h-1 bg-gray-200 rounded-full"></span>
                       <span className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Sanal Tur</span>
                    </div>
                  </div>
                  <div className="flex flex-col items-center lg:items-end gap-3 flex-shrink-0 lg:border-l lg:border-gray-50 lg:pl-8">
                     <p className="text-2xl font-black text-gray-900 tracking-tighter">₺{oda.fiyat}</p>
                     <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest leading-none">GECE BAZLI / VERGİLER DAHİL</p>
                     <button className="bg-gray-900 text-white px-8 py-3.5 rounded-2xl text-[10px] font-black uppercase tracking-widest shadow-xl shadow-gray-200 hover:bg-indigo-600 transition-all hover:scale-105 mt-2">
                        ODAYI SEÇ »
                     </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <UsageInfo 
        color="emerald"
        description="Rezervasyon Formu Önizleme ekranı, müşterilerinizin siteniz üzerinden online rezervasyon yaparken karşılaştıkları arayüzün kopyasıdır. Burası tamamen dinamiktir ve Web Site Ayarlarından yaptığınız değişiklikler buraya anında yansır."
        scenarios={[
          { title: "Simülasyon Mantığı", content: "Bu ekran gerçek bir web tarayıcısı gibi davranır. Sayfa içi navigasyon, buton efektleri ve oda listeleme yapısı müşterilerinizin deneyimiyle birebir aynıdır." },
          { title: "Mobil Uyumluluk", content: "Tarayıcı barındaki daralma efektini inceleyerek formun mobil ekranlarda nasıl konumlandığını (dikey akış) test edebilirsiniz." },
          { title: "Form Kontrolleri", content: "Kişi sayısı, check-in saati gibi ayarların bu önizleme üzerinde doğru çalışıp çalışmadığını son kez onaylayarak sitenizi yayına alabilirsiniz." }
        ]}
      />

      <style>{`
        @keyframes fadeIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
      `}</style>
    </div>
  );
}